var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _ellipse, _ellipse2, _path44, _path45, _ellipse3, _ellipse4, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "basic",
    viewBox: "0 0 64 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22l14-7 40 20-14 7z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M11.3 20.1v3.7l2.5-1.2v-3.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 20.1v3.7l2.5-1.2v-3.8z",
    opacity: 0.39
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M15.7 19.7c-.7-.4-1.4-.4-1.9-.2l-1.4.7c-.5.2-.9.8-.9 1.6 0 1.5 1.3 3.4 2.8 4.2.8.4 1.5.4 2 .2 0 0 1.4-.7 1.5-.8.5-.3.7-.8.7-1.5 0-1.6-1.3-3.4-2.8-4.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 26.1c.2-.1 1.4-.7 1.5-.7.5-.3.7-.8.7-1.5 0-.6-.2-1.3-.5-1.9l-1.4.7c.3.6.5 1.3.5 1.9 0 .7-.3 1.3-.8 1.5z",
    opacity: 0.39
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M16.4 24.2c0 1.2-.9 1.6-2.1 1s-2.1-2-2.1-3.2.9-1.6 2.1-1c1.2.6 2.1 2.1 2.1 3.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25.2c-1.2-.6-2.1-2-2.1-3.2 0-.6.2-1 .6-1.2-.5.1-.8.6-.8 1.2 0 1.2.9 2.6 2.1 3.2.6.3 1.1.3 1.5.1-.4.2-.8.1-1.3-.1z",
    opacity: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M15.4 23.5c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.3.9.8.9 1.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 23.5c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.3.9.8.9 1.3z",
    opacity: 0.39
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M15.2 23.6c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.2.9.8.9 1.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 24.6c0 1.5-1.3 2.2-2.8 1.4-1.5-.8-2.8-2.7-2.8-4.2s1.3-2.2 2.8-1.4c1.5.8 2.8 2.6 2.8 4.2z",
    opacity: 0.06
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M5 15v2l32 16v-2zM51 24v2l-14 7v-2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#28896D",
    d: "M19 4L5 11v4l32 16 14-7v-4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13l8-4V5L7 11z",
    opacity: 0.39
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33L5 17v-6l32 16z",
    opacity: 0.06
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20l-14 7v6l14-7z",
    opacity: 0.39
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#28896D",
    d: "M19 4L5 11l32 16 14-7L19 4zm18 22L7 11l12-6 30 15-12 6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22l4-2L19 5v4z",
    opacity: 0.06
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M45 22L19 9l-8 4 26 13z",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M51 24v2l-14 7v-2zM42.2 32.9c-.7-.4-1.4-.4-1.9-.2l-1.4.7c-.6.2-.9.8-.9 1.6 0 1.5 1.3 3.4 2.8 4.2.8.4 1.5.4 2 .2 0 0 1.4-.7 1.5-.8.5-.3.7-.8.7-1.5 0-1.6-1.3-3.5-2.8-4.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 39.3c.2-.1 1.4-.7 1.5-.7.5-.3.7-.8.7-1.5 0-.6-.2-1.3-.5-1.9l-1.4.7c.3.6.5 1.3.5 1.9 0 .7-.3 1.3-.8 1.5z",
    opacity: 0.39
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M42.9 37.4c0 1.2-.9 1.6-2.1 1s-2.1-2-2.1-3.2.9-1.6 2.1-1 2.1 2 2.1 3.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38.4c-1.2-.6-2.1-2-2.1-3.2 0-.6.2-1 .6-1.2-.5.1-.8.6-.8 1.2 0 1.2.9 2.6 2.1 3.2.6.3 1.1.3 1.5.1-.4.2-.8.1-1.3-.1z",
    opacity: 0.15
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M41.8 36.7c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.6.2.9.8.9 1.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8 36.7c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.6.2.9.8.9 1.3z",
    opacity: 0.39
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M41.7 36.8c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.2.9.8.9 1.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6 37.8c0 1.5-1.3 2.2-2.8 1.4S38 36.5 38 35s1.3-2.2 2.8-1.4 2.8 2.6 2.8 4.2z",
    opacity: 0.06
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M58 18l-6-3-14 7v11.3c0 .3.4.5.7.3 1.2-1 3.3-.3 4.8 1.5.9 1.1 1.3 2.3 1.3 3.3l1.2.6 14-7v-8l-2-6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#39C",
    d: "M46.4 30.5l-1.7-5c-.1-.2 0-.3.2-.4l12.5-6.2c.2-.1.4 0 .5.2l1.6 4.7c.1.2 0 .3-.2.4l-12.4 6.5c-.2.1-.5 0-.5-.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 23.2l8.6-4.3c.2-.1.4 0 .5.2l1.5 4.4-10.6-.3z",
    opacity: 0.15
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M59.4 23.8l-.1-.3c0 .2 0 .3-.2.4l-12.4 6.5c-.2.1-.4 0-.5-.2l.1.3c.1.2.3.3.5.2l12.4-6.5c.2-.1.3-.2.2-.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M49.5 30l7-3.5v5.8l-7 3.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M50 35l6-3v-4.7l-6 3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M60 32v-2l-14 7v2zM44 38l2 1v-2l-2-1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M50 35v1l6-3v-1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#39C",
    d: "M43.5 25.3l-3.8-1.9c-.1-.1-.3 0-.3.2v3c0 .2.1.4.3.4l1.3.7c.1.1.2.1.3.2l1.3 1.6h.1l2.2 1.1c.1.1.3-.1.2-.2l-1.7-5c.2 0 .2-.1.1-.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 30.3l-2-1h-.1l-1.3-1.6c-.1-.1-.2-.2-.3-.2l-1.3-.7c-.2-.1-.3-.2-.3-.4v-2.9l-.2-.1c-.1-.1-.3 0-.3.2v3c0 .2.1.4.3.4l1.3.7c.1.1.2.1.3.2l1.3 1.6h.1l2.2 1.1c.2.1.3 0 .3-.3z",
    opacity: 0.15
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M46 35v2l-.5-.2v-2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M50 31v.3l6-3V28zM50 32v.3l6-3V29zM50 33v.3l6-3V30zM50 34v.3l6-3V31z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M39.5 28.3v.5l1 .5v-.5z",
    opacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M40.5 29.5l-1-.5v-.2l1 .5z",
    opacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M53.5 23.9c-.1-.1-.2-.1-.3 0l-3.8 4.3c-.1.1-.1.2 0 .3s.2.1.3 0l1-1.2v1h.3V27l2.5-2.9c.1 0 .1-.2 0-.2zM57.1 21.9c-.1-.1-.2-.1-.3 0L53 26.2c-.1.1-.1.2 0 .3.1.1.2.1.3 0l.9-1v1.1h.3v-1.4l2.6-3c.1-.1.1-.2 0-.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M58 31l2-1v-2l-1 .5c-.6.3-1 .9-1 1.6v.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7,
    cy: 29.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "scale(-1) rotate(-50.856 -62.142 123.497)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.2,
    cy: 29.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "scale(-1) rotate(-50.856 -62.142 124.549)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M58 31l2-1v-2z",
    opacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46 37l2-1v-.9c0-.5-.5-.8-1-.6l-1 .5v2z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.2,
    cy: 35.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "scale(-1) rotate(-50.856 -74.761 99.31)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.7,
    cy: 35.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "scale(-1) rotate(-50.856 -74.761 98.258)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46 37l2-1-2-1z",
    opacity: 0.3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25l-6-3v11.3c0 .3.4.5.7.3 1.2-1 3.3-.3 4.8 1.5.3.3.5.6.6 1L44 36v2l2 1v-8l-2-6z",
    opacity: 0.06
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18l-14 7 2 6v8l14-7v-8z",
    opacity: 0.39
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/Trailer.0e92292d4f980916d68a64c905a259db.svg";
export { ForwardRef as ReactComponent };